import { render, staticRenderFns } from "./TruthCN.vue?vue&type=template&id=7d2d0ffe&scoped=true&"
import script from "./TruthCN.vue?vue&type=script&lang=js&"
export * from "./TruthCN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2d0ffe",
  null
  
)

export default component.exports